export interface Versioned {
  introducedInVersion: number
}

function disableIfIntroducedInPreviousVersion(versioned: Versioned, currentVersion?: number) {
  if (typeof currentVersion === "undefined" || typeof versioned.introducedInVersion === "undefined") {
    return false;
  } else {
    return !(versioned.introducedInVersion >= currentVersion);
  }
}

export function disableIfIntroducedInPreviousVersionOrOverride(
  versioned: Versioned, 
  currentVersion: number | undefined, 
  override: boolean | undefined
) {
  return disableIfIntroducedInPreviousVersion(versioned, currentVersion) || override;
}

// export function disableIfNotFirstVersionOrOverride(
//   currentVersion: number | undefined, 
//   override: boolean | undefined
// ) {
//   return disableIfIntroducedInPreviousVersion({ introducedInVersion: 1 }, currentVersion) || override;
// }